import React, { createContext, useContext } from 'react';
import type { MinimizableModalWrapperProps } from './types.tsx';

// Need to use this context to prevent re-render flashes in the modal wrapper
const MinimizableModalWrapperPropsContext = createContext<MinimizableModalWrapperProps | null>(
	null,
);

export const useMinimizableModalWrapperProps = (): MinimizableModalWrapperProps => {
	const context = useContext<MinimizableModalWrapperProps | null>(
		MinimizableModalWrapperPropsContext,
	);
	if (context === undefined || context === null) {
		throw new Error('No provider for useMinimizableModalWrapperProps');
	}
	return context;
};

export const MinimizableModalWrapperPropsProvider = ({
	children,
	...rest
}: MinimizableModalWrapperProps) => (
	<MinimizableModalWrapperPropsContext.Provider value={rest}>
		{children}
	</MinimizableModalWrapperPropsContext.Provider>
);
